<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="order-tab" data-bs-toggle="tab" data-bs-target="#order-tab-pane" type="button" role="tab" aria-controls="order-tab-pane" aria-selected="true">بيانات الطلب</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="providers-tab" data-bs-toggle="tab" data-bs-target="#providers-tab-pane" type="button" role="tab" aria-controls="providers-tab-pane" aria-selected="false">المزودين المقترحين</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade p-3 show active" id="order-tab-pane" role="tabpanel" aria-labelledby="order-tab" tabindex="0">
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">نوع الطلب:</label>
                    <div class="d-inline-block ms-2">{{ orderTypes[dataRow.orderType] }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الخدمة:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.MaintenanceIssue.name }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label class="form-label">كوبون الخصم:</label>
                    <div class="d-inline-block ms-2">
                      <span v-if="dataRow.couponId && dataRow.couponAccepted" class="badge bg-success">
                        <i class="fa-solid fa-tag me-1"></i>
                        مُطبَّق —
                        <span v-if="dataRow.couponType === 'percentage'">{{ dataRow.couponAmount }}٪ خصم</span>
                        <span v-else>{{ dataRow.couponAmount }} ريال خصم</span>
                      </span>
                      <span v-else-if="dataRow.couponId && !dataRow.couponAccepted" class="badge bg-warning text-dark">
                        <i class="fa-solid fa-tag me-1"></i>كوبون (لم يُقبل)
                      </span>
                      <span v-else class="badge bg-light text-muted">لا يوجد كوبون</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">اسم العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.User.name }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">جوال العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.User.mobile }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label class="form-label" for="">المزود:</label>
                    <input type="text" class="form-control" placeholder="جوال المزود" @keyup="getProviderData()" v-model="providerMobile">
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <loader v-if="providerLoader" />
                    <div v-if="providerName">
                      <label class="form-label" for="">اسم المزود:</label>
                      <div>{{ providerName }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المنطقة:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المدينة:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">العنوان بالتفصيل:</label>
                    <div>{{ dataRow.description }}</div>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div ref="orderMap" style="width: 100%; height: 350px;"></div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت تعيين المزود:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.assignTime) }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت وصول المزود:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.arriveTime) }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت إتمام الطلب:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.doneTime) }}</div>
                    <div v-if="dataRow.doneNotice" class="d-inline-block ms-2">{{ dataRow.doneNotice }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت إلغاء الطلب:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.cancelTime) }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سعر الباقة:</label>
                    <input type="number" class="form-control" v-model="price" >
                    <div class="form-check mt-2">
                      <input class="form-check-input" type="checkbox" :value="true" v-model="isPaid" id="isPaid">
                      <label class="form-check-label" for="isPaid">
                        تم سداد قيمة الطلب بنجاح
                      </label>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تاريخ الطلب:</label>
                    <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">قيمة عمولة المحيسني العقارية:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.commissionAmount }} ريال</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">نسبة عمولة المحيسني العقارية:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.commissionPercentage }}٪</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">طريقة الدفع:</label>
                    <select v-model="paymentGate" class="form-control">
                      <option value="online">دفع إلكتروني</option>
                      <option value="wallet">محفظة</option>
                      <option value="applepay">ابل باي</option>
                      <option value="cash">كاش</option>
                    </select>
                  </div>
                  <div v-if="dataRow.paymentId" class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">بيانات السداد:</label>
                    <div>
                      <router-link :to="`/payments/update/${dataRow.paymentId}`">عرض بيانات السداد</router-link>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="photosLink" class="form-label">رابط الصور <span v-if="isClosingOrder" class="text-danger">*</span></label>
                    <input id="photosLink" v-model.trim="photosLink" type="url" pattern="[Hh][Tt][Tt][Pp][Ss]?://.*" :required="isClosingOrder" class="form-control" dir="ltr" placeholder="https://">
                    <div class="form-text">يجب إدخال رابط ألبوم الصور قبل إغلاق طلب التصوير.</div>
                    <a v-if="isValidPhotosLink(photosLink)" :href="photosLink" target="_blank" rel="noopener noreferrer" class="d-inline-block mt-2">عرض الصور</a>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة الطلب:</label>
                    <select v-model="status" class="form-control">
                      <!-- <option v-for="(val, key) in orderStatus" :value="key" :key="key">{{ val }}</option> -->
                       <optgroup label="الإدارة">
                        <option value="new">{{ orderStatus['new'] }}</option>
                        <option value="under_review">{{ orderStatus['under_review'] }}</option>
                        <option value="done">{{ orderStatus['done'] }}</option>
                        <option value="admin_done">{{ orderStatus['admin_done'] }}</option>
                      </optgroup>
                      <optgroup label="العميل">
                        <option value="client_canceled">{{ orderStatus['client_canceled'] }}</option>
                        <option value="waiting_deposit">{{ orderStatus['waiting_deposit'] }}</option>
                        <option value="deposit_issue">{{ orderStatus['deposit_issue'] }}</option>
                        <option value="waiting_payment">{{ orderStatus['waiting_payment'] }}</option>
                        <option value="payment_issue">{{ orderStatus['payment_issue'] }}</option>
                      </optgroup>
                      <optgroup label="المزود">
                        <option value="assigned">{{ orderStatus['assigned'] }}</option>
                        <option value="arrived">{{ orderStatus['arrived'] }}</option>
                        <option value="hold">{{ orderStatus['hold'] }}</option>
                        <option value="provier_canceled">{{ orderStatus['provier_canceled'] }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سبب الإلغاء - <small>في حالة كان الطلب لاغي</small> :</label>
                    <select v-model="cancelReason" class="form-control">
                      <option :value="null">غير لاغي</option>
                      <optgroup label="إلغاء من طرف العميل">
                        <option v-for="(val, key) in orderCancelClient" :value="key" :key="key">{{ val }}</option>
                      </optgroup>
                      <optgroup label="إلغاء من طرف المزود">
                        <option v-for="(val, key) in orderCancelProvider" :value="key" :key="key">{{ val }}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div v-if="dataRow.holdTime" class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تاريخ الإقاف المؤقت:</label>
                    <div class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.holdTime) }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سبب التوقف المؤقت:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.holdReason)? orderHoldReasons[dataRow.holdReason] : 'غير معروف' }}</div>
                    <div class="d-inline-block ms-2">{{ dataRow.holdDetails }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تقييم العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.rate }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">ملاحظات العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.rateNote }}</div>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade p-3" id="providers-tab-pane" role="tabpanel" aria-labelledby="providers-tab" tabindex="0">
                <div class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>الجوال</th>
                            <th>الحالة</th>
                            <th>سبب الرفض</th>
                            <th>وقت الارسال</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="acceptance in dataRow.ProvidersOrdersAcceptances" :key="acceptance.id">
                            <td>{{ acceptance.id }}</td>
                            <td>{{ (acceptance.Provider)? acceptance.Provider.name : 'غير معروف' }}</td>
                            <td>{{ (acceptance.Provider)? acceptance.Provider.mobile : 'غير معروف' }}</td>
                            <td>{{ providerAcceptanceStatus[acceptance.status] }}</td>
                            <td>{{ (acceptance.rejectReason)? orderRejectReasons[acceptance.rejectReason] : '' }}</td>
                            <td class="date-format">{{ formatDate(acceptance.createdAt) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, formatDate } from '@/helpers/tools';

export default {
  name: 'PhotosForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    orderStatus: {
      type: Object,
      default: null,
    },
    orderCancelAdmin: {
      type: Object,
      default: null,
    },
    orderTypes: {
      type: Object,
      default: null,
    },
    orderRejectReasons: {
      type: Object,
      default: null,
    },
    orderHoldReasons: {
      type: Object,
      default: null,
    },
    providerAcceptanceStatus: {
      type: Object,
      default: null,
    },
    orderCancelClient: {
      type: Object,
      default: {},
    },
    orderCancelProvider: {
      type: Object,
      default: {},
    },
  },
  data(){
    return {
      formLoader: false,
      providerLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      map: null,
      marker: null,
      providerMobile: null,
      providerName: null,
      providerId: null,
      price: 0,
      status: null,
      cancelReason: null,
      paymentGate: null,
      isPaid: false,
      adminNotice: "",
      photosLink: '',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    isClosingOrder(){
      return ['done', 'admin_done'].includes(this.status);
    },
  },
  methods: {
    formatDate,
    isValidPhotosLink(value){
      if (!/^https?:\/\/\S+$/i.test(value || ''))
        return false;
      try {
        const url = new URL(value);
        return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
      } catch (error) {
        return false;
      }
    },
    subimtData(){
      this.hasError = false;
      this.hasSucess = false;
      this.errorNumber = 0;
      if ((this.isClosingOrder || this.photosLink) && !this.isValidPhotosLink(this.photosLink)) {
        this.message = 'يجب إدخال رابط صور صحيح يبدأ بـ http:// أو https:// قبل إغلاق طلب التصوير';
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      this.formLoader = true;
      
      const payload = {
        providerId: this.providerId,
        price: this.price,
        status: this.status,
        cancelReason: this.cancelReason,
        paymentGate: this.paymentGate,
        isPaid: this.isPaid,
        adminNotice: this.adminNotice,
        photosLink: this.photosLink || null,
      }
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/photos/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/photos/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/photos').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setImage(files){
      this.image = files[0];
    },
    getProviderData(){
      if(this.providerMobile && this.providerMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.providerLoader = true;
        this.providerId = null;
        this.providerName = null;
        this.$http.post('/api/admin/photos/getProvider', {
          mobile: this.providerMobile.trim(),
        }).then(({data}) => {
          this.providerId = data.provider.id;
          this.providerName = data.provider.name;
          this.providerLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.providerLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    // google map 
    initMap(){
      if (!this.$refs.orderMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.orderMap, {
        center: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
  },
  created(){
    if(this.dataRow){
      this.providerId = this.dataRow.providerId;
      this.price = this.dataRow.price;
      this.status = this.dataRow.status;
      this.cancelReason = this.dataRow.cancelReason;
      this.paymentGate = this.dataRow.paymentGate;
      this.isPaid = this.dataRow.isPaid;
      if(this.dataRow.Provider){
        this.providerMobile = this.dataRow.Provider.mobile;
        this.providerName = this.dataRow.Provider.name;
      }
      this.initialGoogleMap();
      this.adminNotice = this.dataRow.adminNotice;
      this.photosLink = this.dataRow.photosLink || '';
    }
  }
}
</script>
